import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { Row, Col, Modal } from 'react-bootstrap';

import { withRFSToken } from '../../../../Services/axios.js';
import { STATIONLIST } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';

const DownloadGrid = ({ onClose, download_sec, download_tab }) => {
    const isMounted = useRef(false);

    const CentreOptions = [
        { label: 'Dnata', value: 'Dnata' }
    ];

    const [getDestination, setGetDestination] = useState([]);
    const [recoveryAspects, setRecoveryAspects] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [downloadData, setDownloadData] = useState({});
    const options = [];

    const statusOpt = [
        { label: 'New', value: 19 },
        { label: 'In Progress', value: 20 },
        { label: 'Closed', value: 21 },
    ];
    const fetchStationData = async () => {
        try {

            const res = await withRFSToken.post(STATIONLIST, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDropdown = async () => {
        try {

            const res = await withRFSToken.post('service-recovery/dropdown-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // setCommodityType(innerData.commodity_type);
                    // setMovementType(innerData.movement_type);
                    setRecoveryAspects(innerData.recovery_aspects);
                    // setRecoveryInfo(innerData.recovery_information);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchStationData();
        fetchDropdown();
        isMounted.current = true;
    }, []);

    const exportToExcel = async () => {
        let endPoint = '';
        let payload = {};
        switch (true) {
            case download_sec == 'FSM':
                endPoint = 'service-recovery/download';
                payload = {
                    recovery_type: download_tab == 'Active' ? 1 : 0,
                    fields: downloadData
                }
                break;
            default:
                endPoint = '';
                payload = {};
        }
        // console.log('payload', payload);

        try {
            const res = await withRFSToken.post(endPoint, payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    responseType: 'blob',
                }
            )
                .then(response => {
                    const now = new Date();
                    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${formattedDateTime} Downloaded`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    handleModalClose();
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        onClose();
    };
    return (
        <>
            {console.log('downloadData', downloadData)}
            <Modal show={isModalOpen} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Download Filter</h3>
                    <p>Download the document as a selected option</p>
                    <div className='my-4 '>
                        {download_sec == 'FSM' &&
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="12" className='mb-2'>
                                    <Form.Label>Recovery Aspects</Form.Label>
                                    <Select
                                        options={recoveryAspects}
                                        // onChange={(e) => handleDetailsChange(section.uld_number, 'type_code', e.value)}
                                        placeholder="Select"
                                        className='down_selct'
                                        onChange={(selected) => {
                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                            setDownloadData({ ...downloadData, recovery_aspects: selectedValues });
                                            // setDownloadData({ ...downloadData, recovery_aspects: selected.value });
                                        }}
                                        isMulti
                                        name="type_code"
                                        value={options.value}
                                    // isDisabled={section.reg == 'R' ? true : false}
                                    />
                                </Col>
                                <Col sm="12" className='mb-2'>
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        // type="datetime-local"
                                        type="date"
                                        name='start_date'
                                        onChange={(e) => setDownloadData({ ...downloadData, start_date: e.target.value })}
                                    />
                                </Col>
                                <Col sm="12">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name='end_date'
                                        onChange={(e) => setDownloadData({ ...downloadData, end_date: e.target.value })}
                                    />
                                </Col>
                                <Col sm="12" className='mb-2'>
                                    <Form.Label>Origin</Form.Label>
                                    <Select
                                        options={getDestination}
                                        // onChange={(selected) => {
                                        //     const selectedDestination = getDestination.find(option => option.value === selected.value);

                                        // }}
                                        placeholder="Origin"
                                        className='down_selct'
                                        onChange={(selected) => {
                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                            setDownloadData({ ...downloadData, origin: selectedValues });
                                            // setDownloadData({ ...downloadData, origin: selected.value });
                                        }}
                                        isMulti
                                        name="origin"
                                        value={options.value}
                                    />
                                </Col>
                                <Col sm="12" className='mb-2'>
                                    <Form.Label>Destination</Form.Label>
                                    <Select
                                        options={getDestination}
                                        placeholder="Destination"
                                        className='down_selct'
                                        onChange={(selected) => {
                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                            setDownloadData({ ...downloadData, destination: selectedValues });
                                            // setDownloadData({ ...downloadData, destination: selected.value });
                                        }}
                                        isMulti
                                        name="destination"
                                        value={options.value}
                                    />
                                </Col>
                                <Col sm="12">
                                    <Form.Label>Case Status</Form.Label>
                                    <Select
                                        options={statusOpt}
                                        placeholder="Case Status"
                                        className='down_selct'
                                        onChange={(selected) => {
                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                            setDownloadData({ ...downloadData, case_status: selectedValues });
                                        }}
                                        isMulti
                                        name="destination"
                                        value={options.value}
                                    />
                                </Col>
                            </Form.Group>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={exportToExcel}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DownloadGrid;